import RoutesEnum from 'enums/routes.enum'

export default [
    {
        path: '/login',
        name: RoutesEnum.AUTH.LOGIN,
        view: 'auth/Login',
        meta: {
            layout: 'simple',
            title: 'Prijava | Bookeraj',
            description:
                'Prijavite se na svoj nalog kako biste pristupili našoj platformi. Unesite svoje korisničko ime i lozinku.',
        },
    },
    {
        path: '/signup',
        name: RoutesEnum.AUTH.SIGNUP,
        view: 'auth/SignUp',
        meta: {
            layout: 'simple',
            title: 'Registracija | Bookeraj',
            description:
                'Registrujte se i kreirajte svoj nalog na našoj platformi. Popunite potrebne informacije kako biste pristupili svim funkcijama naše usluge.',
        },
    },
    {
        path: '/verify-email',
        name: RoutesEnum.AUTH.VERIFY_EMAIL,
        view: 'auth/VerifyEmail',
        meta: {
            layout: 'simple',
            title: 'Verifikacija E-pošte | Bookeraj',
            description:
                'Potvrdite svoju e-poštu kako biste aktivirali svoj nalog. Pratite link za verifikaciju koji ste primili putem e-pošte i pristupite našoj platformi.',
        },
    },
    {
        path: '/confirm-pending-email',
        name: RoutesEnum.AUTH.CONFIRM_EMAIL,
        view: 'auth/ConfirmPendingEmail',
        meta: {
            layout: 'simple',
            title: 'Potvrda E-pošte u Toku | Bookeraj',
            description:
                'Vaša e-pošta je u procesu potvrde. Pratite upute koje ste dobili putem e-pošte kako biste dovršili proces potvrde.',
        },
    },

    {
        path: '/forgot-password',
        name: RoutesEnum.AUTH.FORGOT_PASSWORD,
        view: 'auth/ForgotPassword',
        meta: {
            layout: 'simple',
            title: 'Zaboravljena Lozinka | Bookeraj',
            description:
                'Resetujte svoju zaboravljenu lozinku. Unesite svoju e-poštu kako biste dobili upute za postavljanje nove lozinke.',
        },
    },
    {
        path: '/reset-password',
        name: RoutesEnum.AUTH.RESET_PASSWORD,
        view: 'auth/ResetPassword',
        meta: {
            layout: 'simple',
            title: 'Resetovanje Lozinke | Bookeraj',
            description:
                'Resetujte svoju lozinku kako biste ponovo dobili pristup svom nalogu. Unesite svoju e-poštu i pratite upute za postavljanje nove lozinke.',
        },
    },
    {
        path: '/fin-acc',
        name: RoutesEnum.AUTH.FINALIZE_ACCOUNT,
        view: 'auth/FinalizeProfile',
        meta: {
            layout: 'simple',
            title: 'Bookeraj - Rezerviši i Pruži Usluge Online',
            description:
                'Naše online mesto vam omogućava da lako rezervišete različite usluge ili ponudite svoje usluge drugima. Pronađite i rezervišite ono što vam treba.',
        },
    },
]
